import { Log } from '@/shared/Log';
import { FetchError, fetch } from '@/shared/fetch';

import { CallStartError } from '../model/CallStartError';

function openCall(url: string) {
    const parentWidth = window.innerWidth;
    const parentHeight = window.innerHeight;
    const parentX = window.screenX;
    const parentY = window.screenY;

    const savedDimensions = JSON.parse(localStorage.getItem('modalDimensions'));

    const width = savedDimensions?.width || parentWidth;
    const height = savedDimensions?.height || parentHeight;
    const x = savedDimensions?.x || parentX;
    const y = savedDimensions?.y || parentY;
    const newWindow = window.open(
        url,
        'call_popup',
        `width=${width},height=${height},left=${x},top=${y},location=0,toolbar=0,menubar=0,scrollbars=yes,resizable=yes`,
    );
    if (
        !newWindow ||
        newWindow.closed ||
        typeof newWindow.closed === 'undefined'
    ) {
        Log.info('Unable to open call in new window, continued in same tab');
        window.location.href = url;
    }
}

export const initiateVideoCall = async (
    consultationUid: string,
    force: boolean = false,
): Promise<CallStartError | null> => {
    try {
        await fetch('/api/caregivers/call', 'POST', {
            ConsultationUid: consultationUid,
            Force: force,
        });
        openCall(`/caregiver/call/${consultationUid}`);
        return null;
    } catch (error) {
        let status = 500;
        let errorDetail: string | unknown = error;
        if (error instanceof FetchError) {
            status = error.status;
            errorDetail = error.data;
        } else if (error instanceof Error) {
            errorDetail = error.stack || error.message;
        }
        if (status === 409) {
            return CallStartError.isHandledByOther;
        }
        Log.error('Call initiation failed', { status, error: errorDetail });
        return CallStartError.unknown;
    }
};
